import { baseApi } from "./baseApi"

const BASE = `school-page`

const politicsApi = baseApi.injectEndpoints({
    endpoints:(builder)=>({
        getPolitics:builder.query({
            query:(params)=>`${BASE}?school_id=${params.school_id}&type=${params.type}`,
            transformResponse:(req)=>{
                return req.data[0]
            }
        })
    })
})

export const {useGetPoliticsQuery} = politicsApi